import { render, staticRenderFns } from "./permission-setting.vue?vue&type=template&id=3063dc98&scoped=true&"
import script from "./permission-setting.vue?vue&type=script&lang=js&"
export * from "./permission-setting.vue?vue&type=script&lang=js&"
import style0 from "./permission-setting.vue?vue&type=style&index=0&id=3063dc98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3063dc98",
  null
  
)

export default component.exports